import PageFactory from "./PageFactory";

export default class ComponentUtil {


    isChildComponent(component, selectedComponent) {

        if(component.type !== 'RowContainer') {
            return false
        }

        for (let i = 0; i < component.value.length; i++) {
            let childComponent = component.value[i]

            if(childComponent === selectedComponent) {
                return true
            }
        }

        return false
    }

    wrapInContainer(column, component) {

        for (let i = 0; i < column.value.length; i++) {
            let columnComponent = column.value[i]

            if(columnComponent === component) {
                let factory = new PageFactory()
                let rowContainer = factory.createRowContainer()
                rowContainer.value.push(component)
                column.value.splice(i, 1, rowContainer)
                return
            }
        }

    }
}